import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import MediaQuery from 'react-responsive';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const GiveAssuredPanel = ({
    title, imageUrl, description, width
}) => (
        <Container className="panel-padding">
            <Row className="gi-giveassured-panel">
                <Col xs="12" sm="12" md="6" lg="8" className="giveassured-text-part">
                    <div className="giveassured-text-panel">
                        <img src={`${config.cdnUrl}/static/images/home/give-assured-badge20.png`} alt="give assured badge" style={{ height: '24pt' }} />
                        <h4 style={{ paddingTop: '1rem' }}>{title}</h4>
                        <p>{description}</p>
                        <div className="read-more d-flex">
                            <a href="/giveassured" rel="noopener noreferrer" target="_blank" onClick={() => {
                                if (window.eventDispatcher) {
                                    window.eventDispatcher.dispatchEventSync('read-more-giveassured', {}, { amplitude: true });
                                }
                            }}>Read more
                            </a>
                        </div>
                    </div>
                </Col>
                <MediaQuery minWidth={768} device={{ width: width }}>
                    <Col xs="12" sm="12" md="6" lg="4" className="giveassured-image-part">
                        <div className=" d-flex justify-content-center align-self-center giveassured-image-panel">
                            <img src={`${config.cdnUrl}${imageUrl}`} alt="give assured panel image" align="middle" style={{ height: '250px' }} />
                        </div>
                    </Col>
                </MediaQuery>
            </Row>
            <style global jsx>
                {
                    `
                    .gi-giveassured-panel {
                        overflow: hidden;
                        border-radius: 10px;
                        box-shadow: none;
                        border: none;
                        background-color: #f2f2f2;
                        }
                    .giveassured-text-panel{
                        padding: 2rem 2rem 1rem 2rem;
                    }
                    .giveassured-image-panel{
                        padding: 1rem 0rem 1rem 0rem; 
                    }
                    @media (max-width: 768px) {
                        .giveassured-text-panel {
                            padding: 1.5rem 0rem 1rem 0rem;                           
                        }                        
                    }
					`
                }
            </style>
        </Container>
    );



export default GiveAssuredPanel;
